import {Switch} from "@material-ui/core";
import {withStyles} from "@material-ui/core/styles";

/**
 * Genera un Switch teñido con el color indicado.
 * El color se aplica solo cuando el switch está encendido; apagado queda con el color por defecto.
 *
 * Uso (definir a nivel de módulo, no dentro del render):
 *   const RedSwitch = makeColoredSwitch('rgb(255,84,84)');
 *   <RedSwitch checked={...} onChange={...} />
 *
 * @param {string} color - Cualquier color CSS válido (rgb, hex, etc.).
 */
export const makeColoredSwitch = (color) => withStyles({
    switchBase: {
        '&$checked': {
            color: color
        },
        '&$checked + $track': {
            backgroundColor: color
        }
    },
    checked: {},
    track: {}
})(Switch);